import { dataAccessEnvironment } from './data-access-environment';

/**
 * Authorization header for Fleet API which uses a separate JWT from the common one
 */
export class PcmWsAuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `${dataAccessEnvironment.pcmWsApiKey}|${dataAccessEnvironment.authToken}|${new Date().toISOString()}`;
  }
}
